var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * [[RedundantAudioRecoveryMetricReport]] will contain metrics reported
   * by the [[RedundantAudioEncoder]]
   */
  class RedundantAudioRecoveryMetricReport {
    constructor() {
      this.currentTimestampMs = 0;
      this.ssrc = 0;
      this.totalAudioPacketsLost = 0;
      this.totalAudioPacketsExpected = 0;
      this.totalAudioPacketsRecoveredRed = 0;
      this.totalAudioPacketsRecoveredFec = 0;
    }
  }
  exports.default = RedundantAudioRecoveryMetricReport;
  //# sourceMappingURL=RedundantAudioRecoveryMetricReport.js.map
  return exports;
}